function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";
export default (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  width: "12",
  height: "12",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), /*#__PURE__*/React.createElement("path", {
  d: "M11.137 1.805L6.942 6l4.195 4.195-.942.943-4.196-4.195-4.195 4.195-.943-.943L5.057 6 .86 1.805l.943-.943 4.195 4.195L10.195.862l.942.943z",
  fill: "#637282"
})));